<template>
	<modal name="export" :width="300" :height="400">
		<div id="export-modal">
			<h1>{{ $t('exportModal.title') }}</h1>
			<IconTimes class="close-modal" @click.native="$modal.hide('export')" />
			<p>{{ $t('exportModal.text1') }}</p>
			<p v-if="currentUser"><strong>{{ $t('exportModal.text2') }} {{ currentUser.email }}.</strong></p>
			<p>{{ $t('exportModal.text3') }}</p>
			<button type="button" @click="processExport" v-if="!requested">{{ $t('exportModal.exportButton') }}</button>
		</div>
	</modal>
</template>

<script>
	import { mapState } from "vuex";
	import IconTimes from "@/components/icons/IconTimes";
	import axios from "axios";
	import { Dialog } from "@capacitor/dialog";

	export default {
		name: "ExportModal",
		components: {
			IconTimes
		},
		computed: {
			...mapState([ "currentUser" ])
		},
		data() {
			return {
				requested: false
			}
		},
		methods: {
			processExport() {
				axios.request({
					url: `https://server.mangozpevnik.cz/allExport/${this.currentUser.uid}`,
					method: "post"
				}).then(res => {
					this.requested = true;
					if (res.data.status === "ok") {
						Dialog.alert({
							title: "Export",
							message: `Export vám bude zaslán na e-mail ${this.currentUser.email} do několika minut.`
						})
					} else {
						Dialog.alert({
							title: "Export",
							message: "Export je možné provést maximálně jednou za 60 minut."
						})
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	#export-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-weight: 300;

		.close-modal {
			fill: white;
			width: 20px;
			opacity: 0.5;
			position: absolute;
			top: 20px;
			right: 20px;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		h1 {
			margin: 0;
			padding: 20px;
			font-size: 1.4em;
			font-weight: 100;
		}

		p {
			margin: 0 20px 20px 20px;

			a {
				color: rgb(233,196,106);
				text-decoration: underline;

				&:hover {
					color: rgb(211, 177, 97);
				}
			}

			strong {
				font-weight: 600;
			}
		}

		button {
			font-weight: 100;
			margin: 5px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #356173;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				background-color: #2f4f5f;
			}

			&:focus {
				outline: none;
			}
		}
	}
</style>
